module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_56.33130b19.jpg";